<template>
    <crud-facecade
        ref="warnRecord-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
        <template slot="filter">
            <el-col :md="8" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
        </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `warnRecord`,
    props: {

    },
    data() {
        return {
            title: `预警记录`,
            surgeryId: this.$route.query.surgery_id,
            messageList: [],
            url: { baseURL: `/api/Preoperative/Apply/`,
                get: () => {
                    return this.ReloadListData()
                } },
            buttons: [],
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            users: []
        }
    },
    created() {
        this.loadUsers()
    },
    computed: {
        ...mapGetters([`sys_enums`, `screenHeight`]),
        columnList() {
            return [{
                type: `string`,
                prop: `ID`,
                label: `编号`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            },
            {
                type: `string`,
                prop: `VisitNo`,
                label: `住院号`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true
            },
            {
                type: `string`,
                prop: `RoomNo`,
                label: `手术间`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true
            },
            {
                type: `string`,
                prop: `Data_DT`,
                label: `时间`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            },
            {
                type: `string`,
                prop: `Physio_ParamName`,
                label: `项目`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true
            },
            {
                type: `string`,
                prop: `DataValue`,
                label: `异常值`,
                isListable: true,
                width: `180`,
                isExpand: false
            }, {
                type: `string`,
                prop: `WarnContent`,
                label: `预警内容`,
                _isListable: true,
                get isListable() {
                    return this._isListable
                },
                set isListable(value) {
                    this._isListable = value
                },
                isExpand: false
            }
            ]
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 100) || 0
        }
    },
    mounted() {

    },
    methods: {
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        ReloadListData() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetWarnRecordList`, { surgeryInfoId: this.surgeryId, begin: this.rdate[0], end: this.rdate[1] })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`warnRecord-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/WarnRecordList.vue